import Container from '@mui/material/Container';
import { useCurrentTenant, useErrorContext } from '@qpr/client-library';
import createNavItemsViewModel, {
  NavItem,
  NavItemsViewModelType
} from '@qpr/components/Expandable/nav-items-view-model';
import React, { useEffect, useState } from 'react';
import BusinessPortalIcon from '../../../assets/BusinessPortalIcon';
import LandingPageCard from '../components/LandingPageCard';
import LandingPageGrid from '../components/LandingPageGrid';
import LandingPageHeaders from '../components/LandingPageHeaders';
import ImgBusiness from '../images/Business.svg';
import ImgInsights from '../images/Insights.svg';
import ImgOperations from '../images/Operations.svg';
import ImgPerformance from '../images/Performance.svg';
import ImgStrategy from '../images/Strategy.svg';
import ImgValue from '../images/Value.svg';
import createLandingPageViewModel, {
  LandingPageViewModelType,
  Titles
} from './landing-page-view-model';

export interface LandingPageProps {
  navItemsViewModel?: NavItemsViewModelType;
}

const LandingPageView = ({ navItemsViewModel }: LandingPageProps) => {
  const navItemsviewModel: NavItemsViewModelType = navItemsViewModel || createNavItemsViewModel();
  const landingPageViewModel: LandingPageViewModelType = createLandingPageViewModel();

  const { setError } = useErrorContext();

  const [headers, setHeaders] = useState<Titles>({
    title: '',
    description: ''
  });
  const [sections, setSections] = useState<NavItem[]>([]);

  const tenant = useCurrentTenant();
  const tenantSymbol = tenant.symbol;

  useEffect(() => {
    function initIcons(cards: NavItem[]): NavItem[] {
      let card = cards.find(v => v.title.toLowerCase() === 'business');
      if (card !== undefined) card.icon = ImgBusiness;
      card = cards.find(v => v.title.toLowerCase() === 'insights');
      if (card !== undefined) card.icon = ImgInsights;
      card = cards.find(v => v.title.toLowerCase() === 'operations');
      if (card !== undefined) card.icon = ImgOperations;
      card = cards.find(v => v.title.toLowerCase() === 'performance');
      if (card !== undefined) card.icon = ImgPerformance;
      card = cards.find(v => v.title.toLowerCase() === 'strategy');
      if (card !== undefined) card.icon = ImgStrategy;
      card = cards.find(v => v.title.toLowerCase() === 'value');
      if (card !== undefined) card.icon = ImgValue;
      return cards;
    }

    async function initData() {
      setError(null);
      const navItems = await navItemsviewModel.getNavItems();
      const titles = await landingPageViewModel.getTitles();

      if (navItems.error.message) setError(navItems.error);
      if (titles.error.message) setError(titles.error);

      if (navItems && titles) {
        setHeaders(titles.data);
        setSections(initIcons(navItems.data));
      }
    }
    initData();
  }, []);

  return (
    <Container maxWidth="xl" component="main" data-testid="landingpage-main">
      <LandingPageHeaders headers={headers} logo={BusinessPortalIcon} />
      <LandingPageGrid
        card={LandingPageCard}
        tenantSymbol={tenantSymbol}
        sections={sections}
        sizes={{
          xs: 12,
          sm: 3,
          md: 2,
          lg: 2,
          xl: 2
        }}
      />
    </Container>
  );
};

export default LandingPageView;
